import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { leaveVisitRoom } from '../store/waitingRoom/WaitingRoomActions'

/**
 * Clear `inVisitRoom` when the visit pop-up goes away.
 *
 * `useInVisitKeepAlive` reads that flag to suppress the idle logoff, and `lastUserAction` is a
 * single origin-shared key — so a flag left set after a visit ends suppresses the HIPAA
 * §164.312(a)(2)(iii) automatic logoff for EVERY tab, for the rest of that tab's life. An
 * unattended workstation stays authenticated until the keep-alive's 4-hour cap expires.
 *
 * Why unmount, and not the completion handler: the dashboard completes a visit through the Orval mutations in `handleComplete` and dispatches no Redux
 * action at all, so the reducer's `COMPLETE_VISIT_CALL_SUCCESS` / `SUCCESS_VISIT` arm — the
 * classic flow's disarm — is never reached. Unmount is the single point every exit shares:
 * complete, defer, unresolved, finish-later, plain close, and in-person.
 *
 * Dispatching this when the flag is already false is a no-op, so the redundancy is free.
 */
export function useClearInVisitRoomOnUnmount() {
  const dispatch = useDispatch()

  useEffect(
    () => () => {
      dispatch(leaveVisitRoom())
    },
    [dispatch],
  )
}
